import {useTheme, useWindowSize} from '@primer/react-brand/esm'
import {useId} from 'react'

import Styles from './HeroSequence.module.css'

import {Product} from '../../Product/Product'
import {useHeroSequencePlayback} from './use-hero-sequence-playback'
import type {HeroSequenceProps} from './types'

export type {HeroPlaybackState, HeroSequenceProps} from './types'

export const defaultProps: Partial<HeroSequenceProps> = {}

export const HeroSequence = (props: HeroSequenceProps) => {
  const initializedProps: HeroSequenceProps = {...defaultProps, ...props}
  const {video, currentChapterIndex, chaptersAltDesc, videoRef} = initializedProps
  const {videoUrl, handleMetadata, reportPlayback, handleError} = useHeroSequencePlayback(initializedProps)
  const descriptionId = useId()
  const {colorMode} = useTheme()
  const {isSmall: isTablet, isLarge: isDesktop} = useWindowSize()

  return (
    <div className={Styles['HeroSequence']}>
      <Product
        theme={colorMode}
        backgroundProps={{hasCornerDots: true}}
        mediaPosition={isDesktop ? 'bottom-center' : isTablet ? 'center' : 'center-left'}
        productUI={{
          shadowColor: 'green',
          shadowPosition: isDesktop ? 'left' : 'left-bottom',
          roundedCorners: {bottomLeft: !isDesktop, bottomRight: !isDesktop},
        }}
      >
        <div className={Styles.HeroSequence__content}>
          <span id={descriptionId} hidden>
            {chaptersAltDesc[currentChapterIndex]}
          </span>
          {videoUrl && (
            <video
              className={Styles.HeroSequence__video}
              ref={videoRef}
              src={videoUrl}
              aria-label={video?.alt}
              aria-describedby={descriptionId}
              muted
              playsInline
              preload="metadata"
              onLoadedMetadata={handleMetadata}
              onTimeUpdate={reportPlayback}
              onPlay={reportPlayback}
              onPlaying={reportPlayback}
              onPause={reportPlayback}
              onWaiting={reportPlayback}
              onSeeking={reportPlayback}
              onSeeked={reportPlayback}
              onEnded={reportPlayback}
              onError={handleError}
            />
          )}
          {/* TODO: TBC, add JSON animation player component when not using a video? */}
        </div>
      </Product>
    </div>
  )
}
